import React, { useEffect, useState } from 'react'
import styles from 'views/setting/index.module.css'
import { Layer } from 'components'
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil'
import { checkMyDataLinkState, myDataLinkBottomLayerState } from 'states'
import { showMemberEditLayerState, showMemberDropoutLayerState, showMemberOutReasonLayerState, showMyInfoEmailState, showMyInfoNumberState } from './states'
import MemberDropoutLayer from './MemberDropoutLayer'
import MyInfoEmail from 'views/setting/MyInfoEmail'
import Lib from 'library'
import MyInfoNumber from 'views/setting/MyInfoNumber'
import useApp from 'hooks/useApp'

const EditInfoLayer = () => {

    const App = useApp()
    const [showMemberEditLayer, setShowMemberEditLayer] = useRecoilState(showMemberEditLayerState)
    const setShowMemberOutReasonLayer = useSetRecoilState(showMemberOutReasonLayerState)
    const [showMyInfoEmail, setShowMyInfoEmail] = useRecoilState(showMyInfoEmailState)
    const [showMyInfoNumber, setShowMyInfoNumber] = useRecoilState(showMyInfoNumberState)

    const checkMyDataLink = useRecoilValue(checkMyDataLinkState) // 마데 연동 중 상태값
    const setMyDataLinkBottomLayer = useSetRecoilState(myDataLinkBottomLayerState) // my data 연동 중 화면 진입, 또는 API 호출을 막았을 때 노출되는 bottom layer state

    const [myInfoList, setMyInfoList] = useState()
    const [userName, setUserName] = useState()//이름
    const [userNumber, setUserNumber] = useState()//번호
    const [userMail, setUserMail] = useState()//이메일


    //내정보 데이터 가져오기
    const getData = () => {
        Lib.get(`/api/more/myinfo`, data => {
            setMyInfoList(data)
            setUserName(data.mbNm)
            setUserNumber(data.cphNo)
            setUserMail(data.email)
        })
    }

    const logOut = () => {
        // 마데2.0 진입 방지 추가
        if (checkMyDataLink === false) {
            setMyDataLinkBottomLayer(true)
            return
        }
        App.showAlert({
            msg: "로그아웃 하시겠어요?",
            onOk: () => {
                App.logout(() => {
                    Lib.nativeCall("AppManager", "appClose")
                })
            },
            ok: "확인",
            cancel: "취소",
            closeBtn: true,
            confirm: true,
        })
    }

    useEffect(() => {
        if (showMemberEditLayer === true) {
            getData()
        }
    }, [showMemberEditLayer, userMail, userName, userNumber, showMyInfoEmail, showMyInfoNumber])

    return (
        <Layer show={showMemberEditLayer} closeLayer={() => setShowMemberEditLayer(false)}>
            <div className="page">
                <div className="shadow">
                    <div className="padding">
                        <div className={styles.title}>내 정보</div>
                        <ul className="list-item mt_30">
                            <li>
                                <span>이름</span>
                                <span>{userName}</span>
                            </li>
                            <li>
                                <span>휴대폰 번호</span>
                                <div className="flex-align_center" onClick={() => setShowMyInfoNumber(true)}>
                                    <span>{userNumber}</span>
                                    <i className="icon icon_arrow_sm right ml_5" />
                                </div>
                            </li>
                            <li>
                                <span>이메일 주소</span>
                                <div className="flex-align_center" onClick={() => setShowMyInfoEmail(true)}>
                                    <span>{userMail && userMail ? userMail : "-"}</span>
                                    <i className="icon icon_arrow_sm right ml_5" />
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="padding">
                    <ul className={styles["link-menu"]}>
                        <li>
                            <span className={styles.linkSpan} onClick={logOut}>
                                <p>로그아웃</p>
                                <i className="icon icon_arrow_sm right" />
                            </span>
                        </li>
                        <li>
                            <span className={styles.linkSpan} onClick={() => {
                                // 마데2.0 진입 방지 추가
                                if (checkMyDataLink === false) {
                                    setMyDataLinkBottomLayer(true)
                                    return
                                }
                                setShowMemberOutReasonLayer(true)
                            }}>
                                <p>회원탈퇴</p>
                                <i className="icon icon_arrow_sm right" />
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

            <MemberDropoutLayer />
            <MyInfoEmail userMail={userMail} />
            <MyInfoNumber />

        </Layer>
    )
}

export default EditInfoLayer